class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    const core = new Core();
    
    // Cache jQuery selector
    const $items = $(".gr_effect--item");
    const totalItems = $items.length;
    
    // Animation timing constants
    const LOOP_DELAY = 80;
    const FINAL_DELAY = 210;
    const CLEANUP_DELAY = 300;
    //const BUFFER_TIME = 200;
    
    // Function to calculate animation duration based on prizeIndex
    function calculateAnimationTime(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        const loopTime = 2 * totalItems * LOOP_DELAY;
        const finalLoopTime = (targetIndex + 1) * FINAL_DELAY;
        return loopTime + finalLoopTime + CLEANUP_DELAY;
    }
    
    async function animateItems(startIndex, endIndex, delay, removePrevious = true) {
        for (let i = startIndex; i <= endIndex; i++) {
            if (removePrevious && i > 0) {
                $items.eq(i - 1).removeClass("active");
            }
            $items.eq(i).addClass("active");
            await core.wait(delay);
        }
    }
    
    async function animationRandom(prizeIndex) {
        const targetIndex = prizeIndex - 1;
        
        $items.removeClass("active");
        
        for (let loop = 0; loop < 2; loop++) {
            if (loop > 0) {
                $items.eq(totalItems - 1).removeClass("active");
            }
            await animateItems(0, totalItems - 1, LOOP_DELAY);
        }
        
        $items.eq(totalItems - 1).removeClass("active");
        await animateItems(0, targetIndex, FINAL_DELAY);
        
        setTimeout(() => {
            $items.removeClass("active");
        }, CLEANUP_DELAY);
    }

    // Create config object that can be updated dynamically
    const promotionConfig = {
        timeWait: 3900 // Default value, will be updated dynamically
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: promotionConfig,
        animResult: function (listPrize) {
            const prizeIndex = listPrize[0].indexImg;
            
            // Calculate and update timeWait based on animation duration
            promotionConfig.timeWait = calculateAnimationTime(prizeIndex); 
            animationRandom(prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") {
                prodTemplate.fnPromotion();
            }
        },
    });
});
